export const DataGrid = theme => {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          ".MuiDataGrid-withBorderColor": {
            borderColor: "#E6E8F0",
          },
          ".MuiDataGrid-cell": {
            fontWeight: 400,
            alignContent: "center",
          },
        },
        columnHeaders: {
          borderRadius: 0,
        },
        columnHeader: {
          backgroundColor: "#4b4b4b",
          color: "white",
        },
      },
    },
  }
}
